import { useEffect, useState } from 'react';
import { Input, Button, Space, Form, Modal, Divider, Tag } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import ProductVariantService from "services/product_variant"
import CustomerService from "services/customer"

import { PlusSquareOutlined, EditOutlined } from "@ant-design/icons"
import InputNumber from "components/input-number"
import { toSearchText } from "utils/text"

import { useWorkSpace } from "contexts/workspace"
import _ from "lodash"
const service = new CustomerService();

const CustomerInfo = ({ id, open, onClose, onSave }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [editingAddressIndex, setEditingAddressIndex] = useState(-1);
  const { showLoading } = useApp();
  const [form] = Form.useForm()
  const [addressForm] = Form.useForm()

  const normalizeShippingAddress = (list = [], fallback = {}) => {
    let addresses = (list ?? []).map(x => ({
      full_name: x?.full_name ?? fallback.full_name ?? "",
      phone_number: x?.phone_number ?? fallback.phone ?? "",
      address: x?.address ?? "",
      note: x?.note ?? "",
      is_default: !!x?.is_default,
    }));

    if (addresses.length === 0 && fallback.address) {
      addresses = [{
        full_name: fallback.full_name ?? "",
        phone_number: fallback.phone ?? "",
        address: fallback.address ?? "",
        note: "",
        is_default: true,
      }];
    }

    if (addresses.length > 0 && !addresses.some(x => x.is_default)) {
      addresses[0].is_default = true;
    }

    return addresses;
  }

  useEffect(() => {
    setIsModalOpen(open)
    if (open) {
      if (!id)
        form.setFieldsValue({ full_name: "", phone: "", address: "", id: null, shipping_address: [] })
      else {
        loadCustomer();
      }
    }

  }, [open])


  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const btnSaveClick = () => {
    form.submit();
  }

  const onFinish = async values => {
    showLoading(true);

    const currentShippingAddress = form.getFieldValue("shipping_address") ?? [];
    values.shipping_address = normalizeShippingAddress(currentShippingAddress, values);

    if (values.id) {
      var data = await service.update(values);
      if (data) {
        form.setFieldsValue(data);
        await onSave(data);
      }
    } else {
      var data = await service.create(values);
      if (data) {
        form.setFieldsValue(data);
        await onSave(data);
      }
    }

    showLoading(false);
    onClose();




  };

  const loadCustomer = async () => {
    var cus = await service.getByID(id);
    if (cus) {
      form.setFieldsValue({
        ...cus,
        shipping_address: normalizeShippingAddress(cus.shipping_address, cus)
      })
    } else {
      form.setFieldsValue({ full_name: "", phone: "", address: "", id: null, shipping_address: [] })
    }
  }

  const onFinishFailed = values => {
    console.log("value", values)
  };

  const onAddShippingAddress = () => {
    const list = form.getFieldValue("shipping_address") ?? [];
    const next = [
      ...list,
      {
        full_name: form.getFieldValue("full_name") ?? "",
        phone_number: form.getFieldValue("phone") ?? "",
        address: "",
        note: "",
        is_default: list.length === 0,
      }
    ];
    form.setFieldsValue({ shipping_address: next });
  };

  const onSetDefaultShippingAddress = (index) => {
    const list = form.getFieldValue("shipping_address") ?? [];
    const next = list.map((x, i) => ({ ...x, is_default: i === index }));
    form.setFieldsValue({ shipping_address: next });
  };

  const onDeleteShippingAddress = (index) => {
    const list = form.getFieldValue("shipping_address") ?? [];
    const next = list.filter((_, i) => i !== index);
    if (next.length > 0 && !next.some(x => x.is_default)) {
      next[0].is_default = true;
    }
    form.setFieldsValue({ shipping_address: next });
  };

  const openAddShippingAddressModal = () => {
    setEditingAddressIndex(-1);
    addressForm.setFieldsValue({
      full_name: form.getFieldValue("full_name") ?? "",
      phone_number: form.getFieldValue("phone") ?? "",
      address: "",
      note: "",
    });
    setShowAddressModal(true);
  };

  const openEditShippingAddressModal = (index) => {
    const list = form.getFieldValue("shipping_address") ?? [];
    const item = list[index];
    if (!item) {
      return;
    }
    setEditingAddressIndex(index);
    addressForm.setFieldsValue({
      full_name: item.full_name,
      phone_number: item.phone_number,
      address: item.address,
      note: item.note,
    });
    setShowAddressModal(true);
  };

  const onAddressModalOk = async () => {
    const values = await addressForm.validateFields();
    const list = form.getFieldValue("shipping_address") ?? [];
    const next = [...list];
    const addressItem = {
      full_name: values.full_name,
      phone_number: values.phone_number,
      address: values.address,
      note: values.note,
      is_default: list.length === 0,
    };

    if (editingAddressIndex >= 0) {
      addressItem.is_default = !!next[editingAddressIndex]?.is_default;
      next[editingAddressIndex] = addressItem;
    } else {
      next.push(addressItem);
    }

    form.setFieldsValue({ shipping_address: next });
    setShowAddressModal(false);
    setEditingAddressIndex(-1);
  };



  return (
    <>

      <Modal
        title={id ? "Sửa khách hàng" : "Thêm khách hàng"}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        footer={<Space>
          <Button>Close</Button>
          <Button onClick={btnSaveClick} type='primary'>Save</Button>
        </Space>}
      >
        <Form layout='vertical' form={form}

          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >


          <Form.Item
            hidden
            name={"id"}

          >
            <Input />
          </Form.Item>


          <Form.Item
            label="Số điện thoại"
            name={"phone"}
            rules={[

              {
                required: true,
                pattern: /^[0-9]{10}$/,
                message: "Số điện thoại không đúng định dạng",

              },

              {
                validator: async (_, value) => {

                  return new Promise(async (r, e) => {
                    if (!value) {
                      r();
                      return;
                    }
                    if (value.length < 10) {
                      r();
                      return;
                    }

                    try {
                      var data = await service.getByPhone(value);
                      if (id && data?.id && data.id != id) {
                        e(new Error('Số điện thoại này đã được dùng cho khách hàng khác'));
                        return;
                      }
                      if (!id && data) {
                        e(new Error('Số điện thoại này đã được dùng cho khách hàng khác'));
                        return;
                      }

                      // if (data.error) {
                      //   e(new Error('Số điện thoại này đã được đăng ký rồi. Bạn hãy dùng số điện thoại này để đăng nhập nhé'));
                      //   return;
                      // }
                      r();

                    } catch (error) {
                      r();
                    }

                  })




                },
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Họ  và tên"
            name={"full_name"}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Địa chỉ"
            name={"address"}

          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Ghi chú"
            name={"note"}

          >
            <Input />
          </Form.Item>

          <Divider style={{ marginTop: 8, marginBottom: 12 }}>Địa chỉ giao hàng</Divider>
          <Form.Item noStyle shouldUpdate>
            {() => {
              const addresses = form.getFieldValue("shipping_address") ?? [];
              return (
                <Space direction='vertical' style={{ width: "100%" }}>
                  {addresses.map((item, index) => (
                    <div key={index} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10 }}>
                      <Space direction='vertical' style={{ width: "100%" }} size={4}>
                        <Space style={{ justifyContent: "space-between", width: "100%" }}>
                          <Space>
                            <span><b>{item.full_name || "Chưa có tên"}</b> - {item.phone_number || ""}</span>
                            {item.is_default && <Tag color='green'>Mặc định</Tag>}
                          </Space>
                          <Space>
                            <Button type='link' icon={<EditOutlined />} onClick={() => openEditShippingAddressModal(index)} />
                            {!item.is_default && <Button type='link' onClick={() => onSetDefaultShippingAddress(index)}>Mặc định</Button>}
                            <Button type='link' danger onClick={() => onDeleteShippingAddress(index)}>Xoá</Button>
                          </Space>
                        </Space>
                        <div>{item.address}</div>
                        {item.note ? <div style={{ color: "#999" }}>{item.note}</div> : null}
                      </Space>
                    </div>
                  ))}

                  <Button type='link' onClick={openAddShippingAddressModal}>Thêm địa chỉ giao hàng</Button>
                </Space>
              )
            }}
          </Form.Item>

        </Form>
      </Modal>

      <Modal
        title={editingAddressIndex >= 0 ? "Sửa địa chỉ giao hàng" : "Thêm địa chỉ giao hàng"}
        open={showAddressModal}
        onCancel={() => {
          setShowAddressModal(false);
          setEditingAddressIndex(-1);
        }}
        onOk={onAddressModalOk}
      >
        <Form layout='vertical' form={addressForm}>
          <Form.Item label="Người nhận" name="full_name" rules={[{ required: true, message: "Nhập người nhận" }]}>
            <Input />
          </Form.Item>

          <Form.Item
            label="Số điện thoại"
            name="phone_number"
            rules={[
              { required: true, message: "Nhập số điện thoại" },
              { pattern: /^[0-9]{10}$/, message: "Số điện thoại không đúng định dạng" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Địa chỉ" name="address" rules={[{ required: true, message: "Nhập địa chỉ" }]}>
            <Input.TextArea rows={3} />
          </Form.Item>

          <Form.Item label="Ghi chú" name="note">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default CustomerInfo;